import React, { forwardRef } from 'react';
import _ from 'lodash';
import { Text } from '@dutchie/common/components/rebass-compat';
import styled from 'styled-components';
import { RewardsRibbon, RibbonColorPallettes } from 'shared/assets/rewards-ribbon';
import { StyledLink, PinField, SmallLoader } from 'shared/components';
import { CheckoutText } from 'checkout/components/styles/common';
import { mediaQueries } from 'shared/styles';
import { RewardsConnectionStatuses } from 'shared/constants';
import { HeaderText } from 'checkout/components/sections/rewards/styles';

const { blue, green, red } = RibbonColorPallettes;
const { failed, processing, ready, successful } = RewardsConnectionStatuses;

const RewardsPinInput = forwardRef(
  ({ dispensaryName, phoneLastFour, onResendCode, onComplete, status, rewardsProgramDisplayName }, ref) => {
    let colorPalette = blue;
    if (status === failed) {
      colorPalette = red;
    }
    if (status === successful) {
      colorPalette = green;
    }

    // eslint-disable-next-line max-len
    const pinInputBodyText = `Enter the code we sent to (***) *** - ${phoneLastFour} to connect your ${dispensaryName} ${rewardsProgramDisplayName} account.`;

    return (
      <Container>
        <RewardsRibbon pallette={colorPalette} height={66.64} width={66.64} />

        <HeaderText fontSize={14} color='#4f5d68' fontWeight='bold' textAlign='center'>
          {`Connect to ${rewardsProgramDisplayName}`}
        </HeaderText>

        <StyledCheckoutText>{pinInputBodyText}</StyledCheckoutText>

        <PinFieldContainer>
          <PinField
            onComplete={onComplete}
            ref={ref}
            inputStyle={
              status === successful
                ? {
                    color: '#26A27B',
                    backgroundColor: '#F0FFFA',
                    border: '1px solid #26A27B',
                  }
                : {}
            }
          />
        </PinFieldContainer>

        {_.includes([successful, failed], status) && (
          <StyledText status={status} pb={status === failed ? 9 : 0}>
            {status === failed
              ? 'Invalid code, try again'
              : `Success! Scroll down to view your ${rewardsProgramDisplayName}`}
          </StyledText>
        )}

        {_.includes([ready, failed], status) && (
          <StyledLink as='button' fontSize='13px' textAlign='center' onClick={onResendCode}>
            {status === ready ? 'Resend Code' : 'Send a new code'}
          </StyledLink>
        )}

        {status === processing && <StyledSmallLoader height={20} color='#0b99e6' />}
      </Container>
    );
  }
);

export default RewardsPinInput;

const StyledSmallLoader = styled(SmallLoader)`
  padding-top: 12px;
  padding-bottom: 6px;
`;

const StyledText = styled(Text)`
  margin: 0 auto;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;

  color: ${({ theme, status }) => (status === successful ? theme.colors?.primaryGreen : theme.colors?.red[55])};
`;

const StyledCheckoutText = styled(CheckoutText)`
  padding-bottom: 15px;
  line-height: 22px;
  text-align: center;

  @media ${mediaQueries.largePhone} {
    font-size: 12px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  text-align: center;
  padding: 5px 25px 4px;

  @media ${mediaQueries.largePhone} {
    padding: 5px 0 4px;
  }
`;

const PinFieldContainer = styled.div`
  padding: 4px 0 15px;
`;
